import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const updateUserSchema = yup.object({
    // firstName: yup
    //     .string()
    //     .trim()
    //     .required("Απαιτείται όνομα"),
    // lastName: yup
    //     .string()
    //     .trim()
    //     .required("Απαιτείται επώνυμο"),
    userName: yup
        .string()
        .trim()
        .required("Απαιτείται email")
        .email("Μη έγκυρο email"),
    // dob: yup
    //     .string()
    //     .required('Απαιτείται ημ/νία γέννησης'),
    // gender: yup
    //     .string()
    //     .required("Απαιτείται φύλο"),
    roles: yup
        .array()
        .of(yup.mixed()) // ids από checkbox
        .min(1, "Επιλέξτε τουλάχιστον έναν ρόλο!"),
    // isActive: yup.boolean(),
});
